export default "__VITE_ASSET__CHWl8ZSV__"